import { ApiSmpArtGalleryBrandBook } from "./brand_book";
import { ApiSmpArtGalleryCanva } from "./canva";
import { ApiSmpArtGalleryCrello } from "./crello";
import { ApiSmpArtGalleryPolotno } from "./polotno";
import { ApiSmpArtGalleryPolotnoFolder } from "./polotno_folder";
import { ApiSmpArtGalleryUpload } from "./upload";
export class ApiSmpArtGallery {
}
ApiSmpArtGallery.Canva = ApiSmpArtGalleryCanva;
ApiSmpArtGallery.Crello = ApiSmpArtGalleryCrello;
ApiSmpArtGallery.Polotno = ApiSmpArtGalleryPolotno;
ApiSmpArtGallery.PolotnoFolder = ApiSmpArtGalleryPolotnoFolder;
ApiSmpArtGallery.BrandBook = ApiSmpArtGalleryBrandBook;
ApiSmpArtGallery.Upload = ApiSmpArtGalleryUpload;
//# sourceMappingURL=art_gallery.js.map